export default __webpack_public_path__ + "static/media/1.5313e5df.png";